import { render, staticRenderFns } from "./ordered-user-team-selector.vue?vue&type=template&id=262460a2"
import script from "./ordered-user-team-selector.vue?vue&type=script&lang=js"
export * from "./ordered-user-team-selector.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports